/**
 * @file Cart page
 */

import vCartBody from '../components/cart-body/cart-body';

/**
 * Cart functions
 *
 * Runs component js and any cart-related tasks
 */
const vCart = () => {
	vCartBody();
};

if (document.readyState !== 'loading') {
	vCart();
} else {
	document.addEventListener('DOMContentLoaded', vCart);
}
